export default __webpack_public_path__ + "static/demand-academy-body-dc831922ca5f35d5413ddc41fae5b57f.jpg";